<template>
    <section class="form">
        <form @submit.prevent="addNewBeer" class="form-beer">
            <h1>Add a New Beer</h1>
            <div>
                <label class="sr-only">Name</label>
                <input v-model="beer.beerName" placeholder="Name" type="text" />
            </div>
            <div>
                <label class="sr-only"> Beer Style</label>
                <input v-model="beer.style" placeholder="Beer Style" type="text" />
            </div>
            <div>
                <label class="sr-only">Price</label>
                <input v-model="beer.price" placeholder="Price" type="text" />
            </div>
            <label class="sr-only"> ABV</label>
            <input v-model="beer.abv" placeholder="ABV" type="text" />
            <div>
                <label class="sr-only">Image URL</label>
                <input v-model="beer.imageUrl" placeholder="Image URL" type="text" />
            </div>
            <label class="sr-only">Description</label>
            <textarea v-model="beer.description" placeholder="Description" type="text"></textarea>
            <div>
                <button type="submit" class="button">Submit</button>
                <button v-on:click.prevent="resetForm" class="button">Cancel</button>
            </div>
        </form>
    </section>
</template>

<script>
export default {
    methods: {
        addNewBeer() {
            this.$store.commit("ADD_BEER",this.beer);
            this.$router.push(`/brewery/${parseInt(this.$route.params.id)}`);
        },
        resetForm() {
            this.$router.push(`/brewery/${parseInt(this.$route.params.id)}`);
        },
    },
    data() {
        return {
            message: "",
            beer: {
                beerId: this.$store.getters.getNextBeerId,
                brewery_id: parseInt(this.$route.params.id),
                beerName: "",
                style: "",
                price: "",
                abv: "",
                imageUrl: "",
                description: "",
            },
        };
    },
}
</script>